import { useState, useEffect } from 'react';
import { makeStyles, TableBody, Paper, Toolbar, TableRow, TableCell, InputAdornment } from '@material-ui/core';
import Notifications from '../../components/Notifications';
import { Dialog } from '../../components/Dialog';
import { Search } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';
import ActionButton from '../../components/controls/ActionButton';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import useTable from '../../components/useTable';
import PageHeader from '../../components/PageHeader';
import FlipToFrontIcon from '@material-ui/icons/FlipToFront';
import Input from '../../components/controls/Input';
import Button from '../../components/controls/Button';
import CustomerTypeForm from './CustomerTypeForm';
import AddIcon from '@material-ui/icons/Add';
import { disableOrgType, getAllOrgTypes, insertOrgType, updateOrgType } from '../../services/masterOrgTypeService';

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: '75%',
  },
  newButton: {
    position: 'absolute',
    right: '10px',
  },
}));

const DistributorTypesList = () => {
  const [materials, setMaterials] = useState([]);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  });
  const classes = useStyles();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { id: 'title', label: 'Title', disableSorting: true },
    { id: 'description', label: 'Description', disableSorting: true },
    // { id: 'rate', label: 'Special Rate', disableSorting: true },
    { id: 'status', label: 'Status', disableSorting: true },
    { id: 'action', label: 'Action', disableSorting: true },
  ];

  const fetchAllOrgTypes = async () => {
    const materialLists = await getAllOrgTypes();
    // const mLists = materialLists.data?.data;
    setMaterials(materialLists);
  };
  useEffect(() => {
    fetchAllOrgTypes();
  }, []);

  const handlePopUpOpen = () => {
    setRecordForEdit(null);
    setOpenPopUp(true);
  };

  const handleClose = () => {
    setOpenPopUp(false);
  };

  const onDelete = (id) => {
    if (window.confirm('Are you sure to disable this record')) {
      disableOrgType(id);
      setNotify({
        isOpen: true,
        message: 'Customer Type Disabled Successfully',
        type: 'error',
      });
      fetchAllOrgTypes();
      // window.location.reload();
    }
  };

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === '') {
          return items;
        } else {
          return items.filter((x) => x.title.toLowerCase().includes(target.value.toLowerCase()));
        }
      },
    });
  };

  const addOrEdit = async (material, resetForm) => {
    console.log(material);
    if (!material.id) {
      // material.status = 1;
      const response = await insertOrgType(material);
      console.log(response);
    } else {
      await updateOrgType(material);
    }
    resetForm();
    setRecordForEdit(null);
    setOpenPopUp(false);
    setNotify({
      isOpen: true,
      message: 'Submitted successfully',
      type: 'success',
    });
    fetchAllOrgTypes();
    // window.location.reload();
  };

  const openInPopUp = (row) => {
    setRecordForEdit(row);
    setOpenPopUp(true);
  };

  const { TableContainer, TableHeader, TablePaginations, recordsAfterPagingAndSorting } = useTable(
    materials,
    headCells,
    filterFn, [5, 10, 25, { label: 'All', value: materials?.length || 100 }]
  );

  return (
    <>
      <PageHeader title="Master Customer Types" subTitle="Master Customer Types addition and listing" icon={<FlipToFrontIcon />} />
      <Paper className={classes.pageContent}>
        <Toolbar>
          <Input
            label="Search by Type name"
            className={classes.searchInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
          />
          <Button
            text="Add New"
            variant="outlined"
            startIcon={<AddIcon />}
            className={classes.newButton}
            onClick={handlePopUpOpen}
          />
        </Toolbar>
        <TableContainer>
          <TableHeader />
          <TableBody>
            {recordsAfterPagingAndSorting()?.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.state_name}</TableCell>
                {/* <TableCell>{row.rate}</TableCell> */}
                <TableCell>{row.status}</TableCell>
                <TableCell>
                  <ActionButton
                    onClick={() => {
                      openInPopUp(row);
                    }}
                    color="primary"
                  >
                    <EditOutlinedIcon fontSize="small" />
                  </ActionButton>
                  <ActionButton color="secondary" onClick={() => onDelete(row.id)}>
                    <DeleteIcon fontSize="small" />
                  </ActionButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableContainer>
        <TablePaginations />
      </Paper>
      <Dialog heading="Add Customer Type" handleClose={handleClose} open={openPopUp} width="xs">
        <CustomerTypeForm
          materials={materials}
          recordForEdit={recordForEdit}
          addOrEdit={addOrEdit}
        />
      </Dialog>
      <Notifications notify={notify} setNotify={setNotify} />
    </>
  );
};
export default DistributorTypesList;
